console.log("Inventory V2 Active");

/* -------------------------------------------------
   GLOBAL INVENTORY FUNCTION
--------------------------------------------------*/

window.updateVariantInventoryV2 = function (variant) {

  if (!variant) return;

  const statusEl = document.querySelector(".variant-inventory-status-v2");
  if (!statusEl) return;

  const container = statusEl.closest("product-rerender");
  if (!container) return;

  const productId = statusEl.dataset.productId;
  const script = container.querySelector(`#VariantInventoryDataV2-${productId}`);
  if (!script) return;

  let map;

  try {
    map = JSON.parse(script.textContent);
  } catch (e) {
    console.error("Inventory V2 JSON Error", e);
    return;
  }

  const entry = map[String(variant.id)];
  if (!entry) return;

  /* Dropdown-Fix */
  let source = entry.stock_source;

  if (Array.isArray(source)) {
    source = source[0];
  }

  source = (source || "").toLowerCase().trim();

  const textEl = statusEl.querySelector(".inventory-text");
  const noteEl = statusEl.querySelector(".inventory-note");

  if (!textEl) return;

  let statusText = "";
  let colorClass = "orange";

  /* -------------------------------------------------
     LOGIC ENGINE
  --------------------------------------------------*/

  /* LOKAL */
  if (source === "lokal") {

    if (entry.inventory_quantity > 0) {
      statusText = "Sofort lieferbar";
      colorClass = "green";
    } else {
      statusText = "In Kürze wieder lagernd";
      colorClass = "orange";
    }

  }

    /* HERSTELLER */
  else if (source === "hersteller") {

    const value = parseInt(entry.delivery_time_value, 10);
    const unit = String(entry.delivery_time_unit || "days").toLowerCase().trim();

    if (!isNaN(value) && value > 0) {

      if (unit === "days") {
        statusText = value === 1
          ? "In 1 Werktag lieferbar"
          : `In ${value} Werktagen lieferbar`;
      }

      else if (unit === "weeks") {
        statusText = value === 1
          ? "In 1 Woche lieferbar"
          : `In ${value} Wochen lieferbar`;
      }

      else if (unit === "months") {
        statusText = value === 1
          ? "In 1 Monat lieferbar"
          : `In ${value} Monaten lieferbar`;
      }

      else {
        statusText = `In ${value} Werktagen lieferbar`;
      }

    } else {
      statusText = "Lieferbar";
    }

    colorClass = "green";
  }

  /* VORBESTELLUNG */
  else if (source === "vorbestellung") {
    statusText = "Vorbestellbar";
    colorClass = "orange";
  }

  /* AUF ANFRAGE */
  else if (source === "auf anfrage") {
    statusText = "Auf Anfrage verfügbar";
    colorClass = "orange";
  }

  /* AUSLAUFMODELL */
  else if (source === "auslaufmodell") {
    statusText = "Nicht mehr verfügbar";
    colorClass = "red";
  }

  /* FALLBACK – STANDARD LAGERPRODUKT */
else {

  statusText = "Sofort lieferbar";
  colorClass = "green";

}

  /* -------------------------------------------------
     APPLY TO DOM
  --------------------------------------------------*/

  textEl.textContent = statusText;

  if (noteEl) {
    noteEl.textContent = entry.manual_note || "";
  }

  /* Nachfolger-Knopf nur bei Auslaufmodell (2026-09-30) */
  const successorEl = statusEl.querySelector(".inventory-successor");
  if (successorEl) {
    successorEl.hidden = source !== "auslaufmodell";
  }

  statusEl.classList.remove("is-ok", "is-low", "is-discontinued");

  if (colorClass === "green") {
    statusEl.classList.add("is-ok");
  } else if (colorClass === "red") {
    statusEl.classList.add("is-discontinued");
  } else {
    statusEl.classList.add("is-low");
  }

};


/* -------------------------------------------------
   IMPACT THEME INTEGRATION
--------------------------------------------------*/

function getCurrentVariantFromContainer() {

  const statusEl = document.querySelector(".variant-inventory-status-v2");
  if (!statusEl) return null;

  const container = statusEl.closest("product-rerender");
  if (!container) return null;

  const form = container.querySelector('form[action^="/cart/add"]');
  if (!form) return null;

  const idInput = form.querySelector('input[name="id"]');
  if (!idInput) return null;

  return { id: idInput.value };
}


/* Variant Change Events */

document.addEventListener("variant:change", function (event) {
  if (event.detail?.variant) {
    window.updateVariantInventoryV2(event.detail.variant);
  }
});

document.addEventListener("product:variant-change", function (event) {
  if (event.detail?.variant) {
    window.updateVariantInventoryV2(event.detail.variant);
  }
});

document.addEventListener("product:rerender", function (event) {
  if (event.detail?.variant) {
    window.updateVariantInventoryV2(event.detail.variant);
  }
});


/* Initial Load */

window.addEventListener("load", function () {

  setTimeout(() => {

    const variant = getCurrentVariantFromContainer();

    if (variant) {
      window.updateVariantInventoryV2(variant);
    }

  }, 300);

});
